module.exports = __webpack_public_path__ + "img/04.97b04b35.jpg";